import { Injectable } from '@angular/core';
// import { Observable } from 'rxjs';

import { FirestorePathsService } from './firestorePaths.service';
import { FirestoreService } from '../lib/firestore.service';

import type {
    TIsoTimezone,
    TIsoTimezones
} from '@shared/models';
@Injectable({
    'providedIn': 'root'
})
export class IsoTimezonesService {
    constructor(private firestoreService: FirestoreService, private firestorePathsService: FirestorePathsService) {
    }

    public getNullable(): TIsoTimezone {
        const timezone: TIsoTimezone = {
            offset: '',
            timezoneName: '',
            caption: ''
        };
        return timezone;
    }

    public async getByFieldValue(fieldName: string, fieldValue: string): Promise<TIsoTimezone> {
        const path = this.firestorePathsService.getIsoTimezonesPath();
        return this.firestoreService.getByFieldValue(path, fieldName, fieldValue) as Promise<TIsoTimezone>;
    }

    public async getByUid(uid: string): Promise<TIsoTimezone> {
        const path = this.firestorePathsService.getIsoTimezonesPath();
        return this.firestoreService.getByUid(path, uid) as unknown as Promise<TIsoTimezone>;
    }

    // private getIsoTimezonesReference() {
    //     const path = this.firestorePathsService.getIsoTimezonesPath();
    //     const timezonesDoc = path.doc('allTimezones');
    //     const ref = timezonesDoc.ref;
    //     return ref;
    // }

    // public async get(): Promise<TIsoTimezones> {
    public async get(): Promise<TIsoTimezone[]> {
        const path = this.firestorePathsService.getIsoTimezonesPath();
        const isoTimezones: TIsoTimezones = await this.firestoreService.get(path) as TIsoTimezones;

        const sortedTimezones = this.sort(isoTimezones.timezones);
        return sortedTimezones;
    }

    // // public async getAll(): Promise<TIsoTimezone[]> {
    // public async getAll(): Promise<TIsoTimezone[]> {
    //     const collection = this.firestorePathsService.getIsoTimezonesPath();
    //     // const allTimezones = await this.firestoreService.getAll(collection) as TIsoTimezone[];
    //     // const isoTimezones = await this.firestoreService.getAll(collection) as TIsoTimezones;
    //     const isoTimezones = await this.firestoreService.getAll(collection);
    //     const allTimezones = isoTimezones.allTimezones;
    //     // const timezones = allTimezones[0].timezones;
    //     // const timezones = allTimezones.so;
    //     return this.sort(allTimezones);
    // }

    public async add(timezone: TIsoTimezone): Promise<TIsoTimezone> {
        const collection = this.firestorePathsService.getIsoTimezonesPath();
        return this.firestoreService.add(collection, timezone) as Promise<TIsoTimezone>;
    }

    public async set(timezones: TIsoTimezones): Promise<TIsoTimezones> {
        // timezone.uid = timezone.uid;
        const collection = this.firestorePathsService.getIsoTimezonesPath();
        await this.firestoreService.set(collection, timezones);
        return timezones;
    }

    public async update(timezone: TIsoTimezones): Promise<TIsoTimezones> {
        const path = this.firestorePathsService.getIsoTimezonesPath();
        return this.firestoreService.update(path, timezone) as Promise<TIsoTimezones>;
    }

    public async delete(uid: string): Promise<void> {
        const path = this.firestorePathsService.getIsoTimezonesPath();
        return this.firestoreService.delete(path, uid);
    }

    public sort(timezones: TIsoTimezone[]): TIsoTimezone[] {
        // const allTimezones = timezones.allTimezones;
        const sortedTimezones = timezones.sort((a, b) => {
            // return a.localCompare(b);    // localCompare doesn't exist, so do the compare ourselves
            if (a.offset < b.offset) {
                return -1;
            } else if (a.offset > b.offset) {
                return 1;
            } else {
                return 0;
            }
        });

        return sortedTimezones;
    }
}
